module.exports = __webpack_public_path__ + "img/TR.d814cb57.png";